var map = {
	"./AnnualFieldTrips1.jpeg": 2751,
	"./AnnualFieldTrips2.jpeg": 9154,
	"./AnnualFieldTrips3.jpeg": 1353,
	"./AnnualFieldTrips4.jpeg": 8956,
	"./AnnualFieldTrips5.jpeg": 1235,
	"./AnnualFieldTrips6.jpeg": 4966,
	"./AnnualFieldTrips7.jpeg": 1837,
	"./WhatsApp Image 2026-03-17 at 1.31.10 PM (1).jpeg": 4095,
	"./WhatsApp Image 2026-03-17 at 1.31.10 PM.jpeg": 3625,
	"./WhatsApp Image 2026-03-17 at 1.33.34 PM.jpeg": 9501,
	"./WhatsApp Image 2026-03-17 at 1.33.35 PM.jpeg": 8704,
	"./WhatsApp Image 2026-03-17 at 1.33.36 PM (1).jpeg": 3021,
	"./WhatsApp Image 2026-03-17 at 1.33.36 PM.jpeg": 1079,
	"./WhatsApp Image 2026-03-17 at 1.33.37 PM (1).jpeg": 6844,
	"./WhatsApp Image 2026-03-17 at 1.33.37 PM (2).jpeg": 5291,
	"./WhatsApp Image 2026-03-17 at 1.33.37 PM.jpeg": 2066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5021;